/**
 * PermissionGate — esconde children quando o usuario nao tem a permissao.
 *
 * Pente fino RBAC (12/06/2026): botoes de acao (Novo/Editar/Excluir/
 * Importar/Exportar) devem sumir quando a flag correspondente da tela
 * nao esta marcada na matriz de permissoes. MASTER sempre passa (bypass
 * embutido nos helpers do authStore).
 *
 * Uso:
 *   <PermissionGate tela="HOSPITAIS_LIST" acao="editar">
 *     <button onClick={onEdit}>Editar</button>
 *   </PermissionGate>
 *
 * Para logica fora de JSX (duplo-clique, menu de contexto), use o hook
 * usePermissoesTela(tela).
 */
import React from 'react';
import useAuthStore from '../stores/authStore';

export type AcaoPermissao = 'visualizar' | 'criar' | 'editar' | 'excluir' | 'exportar';

interface PermissionGateProps {
  tela: string;
  acao: AcaoPermissao;
  children: React.ReactNode;
}

export function usePermissoesTela(tela: string) {
  const podeVisualizar = useAuthStore((s: any) => s.podeVisualizar(tela));
  const podeCriar = useAuthStore((s: any) => s.podeCriar(tela));
  const podeEditar = useAuthStore((s: any) => s.podeEditar(tela));
  const podeExcluir = useAuthStore((s: any) => s.podeExcluir(tela));
  const podeExportar = useAuthStore((s: any) => s.podeExportar(tela));
  return { podeVisualizar, podeCriar, podeEditar, podeExcluir, podeExportar };
}

const PermissionGate: React.FC<PermissionGateProps> = ({ tela, acao, children }) => {
  const perms = usePermissoesTela(tela);
  const allowed = {
    visualizar: perms.podeVisualizar,
    criar: perms.podeCriar,
    editar: perms.podeEditar,
    excluir: perms.podeExcluir,
    exportar: perms.podeExportar,
  }[acao];

  if (!allowed) return null;
  return <>{children}</>;
};

export default PermissionGate;
